import { WHITE_LABEL } from 'config';

enum WhiteLabelProvidersEnum {
  ACCUSHIELD = 'accushield',
  PETAL = 'petal',
  WHITE_LABEL_DEMO = 'white_label_demo',
}

const WhiteLabelProviders = Object.values(WhiteLabelProvidersEnum) as string[];

function isWhiteLabelled() {
  return WhiteLabelProviders.includes(WHITE_LABEL);
}

const whiteLabelProvider: Nullable<WhiteLabelProvidersEnum> = !isWhiteLabelled()
  ? null
  : (WHITE_LABEL as WhiteLabelProvidersEnum);

const isAccushieldProvider = whiteLabelProvider === WhiteLabelProvidersEnum.ACCUSHIELD;
const isPetalProvider = whiteLabelProvider === WhiteLabelProvidersEnum.PETAL;
const isWhiteLabelDemoProvider = whiteLabelProvider === WhiteLabelProvidersEnum.WHITE_LABEL_DEMO;

const BRAND_NAMES: Record<WhiteLabelProvidersEnum, string> = {
  [WhiteLabelProvidersEnum.ACCUSHIELD]: 'Accushield',
  [WhiteLabelProvidersEnum.PETAL]: 'Petal',
  [WhiteLabelProvidersEnum.WHITE_LABEL_DEMO]: 'White Label Demo',
};

const brandName = whiteLabelProvider ? BRAND_NAMES[whiteLabelProvider] : 'BookJane';

export const WhiteLabelAccessor = {
  WhiteLabelProvidersEnum,
  isWhiteLabelled,
  isAccushieldProvider,
  isPetalProvider,
  isWhiteLabelDemoProvider,
  whiteLabelProvider,
  brandName,
};
